import type { Dtos } from "@inrev/common";
import { Button } from "@portal/components/ui/Button";
import { QuickSubmitLayout } from "../../../account/create/quick-submit/QuickSubmitLayout";
import { AgencySection } from "./sections/AgencySection";
import { BondSection } from "./sections/BondSection";
import { PrincipalSection } from "./sections/PrincipalSection";

export const BondRequestQuickSubmit = ({
	onSubmit,
	openFullSubmission,
	header,
	agentPreviews,
	isSubmitting,
}: {
	onSubmit: () => void;
	openFullSubmission: () => void;
	header: React.ReactNode;
	agentPreviews: Dtos.Agent.Preview.Get.Response[] | undefined;
	isSubmitting?: boolean;
}) => {
	return (
		<QuickSubmitLayout
			openFullSubmission={openFullSubmission}
			header={header}
			fullSubmissionTrackingId="bond-request-admin-escalate"
		>
			<div className="flex flex-col gap-4">
				<div className="grid grid-cols-[1fr_1fr_auto] grid-rows-[1fr_auto_auto] gap-4 pt-[18px]">
					<AgencySection agentPreviews={agentPreviews} />
					<PrincipalSection />
					<BondSection />
				</div>
				<div className="h-0" />
				<Button
					color="confirm"
					filled
					fullWidth
					onClick={onSubmit}
					trackingId="bond-request-admin-quick-submit"
					loading={isSubmitting}
				>
					Submit
				</Button>
			</div>
		</QuickSubmitLayout>
	);
};
